import React, { Component } from 'react'
import { productDetail } from 'src-features/api/productDetail';
import LoaderCover from 'src-features/commonUI/loadingCover';
import Product from '../component'
class ProductDetail extends Component {
    state = {
        isLoading: true,
        hasError: false,
        data: {}
    }
    fetchData = async() => {
        this.setState({
            isLoading: true,
            hasError: false
        })
        let data = await productDetail(this.props.match.params);
        if (data.isError || data.ret !== 0) {
            this.setState({
                isLoading: false,
                hasError: true
            })
        } else {
            this.setState({
                isLoading: false,
                data: {...data.data}
            })
        }
    }
    componentDidMount() {
        this.fetchData();
    }
    render() {
        console.log(this.props.match.params)
        return (
            <div>
            {!this.state.isLoading && <Product {...this.state.data} />}
            <LoaderCover loading={this.state.isLoading}/>
            </div>
        )
    }
}

export default ProductDetail


// WEBPACK FOOTER //
// ./src/features/product/productDetail/container/index.js